module.exports = " <div :class=\"['notification', 'animated', type ? `is-${type}` : '']\" :transition=transition transition-mode=in-out> <button class=\"delete touchable\" @click=close()></button> <div class=\"title is-5\" v-if=title>{{ title }}</div> {{ message }} </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-notification/src/Notification.vue
// module id = 926
// module chunks = 2